import { applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { enableMock, disableMock } from "async-ops";
import { mdaeWidgetDataUpdaterMiddleware } from "../common_components/mdae-framework";
import { thunk } from 'redux-thunk';
import { apiMiddleware, rtkQueryApis } from "./api-middleware";
import { createRtkQueryLoaderMiddleware } from "./rtk-query-loader-middleware";

export const sagaMiddleware = createSagaMiddleware();

export default () => {
  const middleware = [];

  window.enableMock = enableMock;
  window.disableMock = disableMock;
  middleware.push(sagaMiddleware);
  middleware.push(thunk);
  middleware.push(mdaeWidgetDataUpdaterMiddleware);
  // RTK Query's cache lifecycle for every registered API — see ./api-middleware.
  middleware.push(...apiMiddleware);
  // Raises the same global loader those APIs' requests would otherwise miss out
  // on, since they don't dispatch the async-ops actions mdaeWidgetDataUpdaterMiddleware
  // watches for.
  middleware.push(createRtkQueryLoaderMiddleware(rtkQueryApis));
  return applyMiddleware(...middleware);
};
